<template>
  <div class="mc-widget-call-broadcast__item-ongoing-wrapper">
    <div>
      <h4 class="mc-widget-call-broadcast__licenseplate">{{ licensePlate }}</h4>
      <p class="mc-widget-call-broadcast__driver">{{ driver ?? $t('global.text.noDriver') }}</p>
    </div>
    <div class="mc-widget-call-broadcast__state-title-wrapper">
      <p class="mc-widget-call-broadcast__state-title" :class="{ hidden: isAfter1Second }">
        {{ $t('trackVideo.connected') }}
      </p>
      <i class="mc-fa icon-fill_close" @click="$emit('endBroadcast')" />
    </div>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'

export default {
  name: 'StateOnGoing',
  mixins: [Helper],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      validator: (value) => typeof value === 'string' || value === null,
      required: true,
    },
  },

  data() {
    return {
      isAfter1Second: false,
    }
  },

  async mounted() {
    await this.delay(1000)
    this.isAfter1Second = true
  },
}
</script>
<style lang="scss">
.mc-widget-call-broadcast__item-ongoing-wrapper {
  display: flex;
  align-items: start;
  justify-content: space-between;
  p.mc-widget-call-broadcast__state-title {
    color: $green-500;
  }
  .mc-widget-call-broadcast__state-title.hidden {
    display: none;
  }
}
</style>
